import { render, staticRenderFns } from "./ProjectMatchingProjectsModal.vue?vue&type=template&id=6cbe2fb8"
import script from "./ProjectMatchingProjectsModal.vue?vue&type=script&lang=ts"
export * from "./ProjectMatchingProjectsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports